<template>
  <div>
    <p>
      {{ $t('check') }}
    </p>
    <ol>
      <li>
        {{ $t('p1') }} <mdicon name="lock-outline" />;
      </li>
      <li>
        {{ $t('p2') }}
      </li>
      <li>
        {{ $t('p3') }}
      </li>
      <li>
        {{ $t('p4') }}
      </li>
    </ol>
    <br>
    <div>
      <p>
        {{ $t('i1') }} <a target="_blank" href="https://support.google.com/googleplay/answer/6270602">{{ $t('more') }}</a>.
      </p>
    </div>
  </div>
</template>

<script>
import { mdiLockOutline } from '@mdi/js';

export default {
  name: 'NotAllowedAndroidChrome',
};
</script>

<style scoped>

</style>

<i18n locale="en" lang="yaml">
check: Failed to access camera and microphone.
p1: To the left of the site address, click on the lock icon
p2: Click on the Permissions section;
p3: Allow access to Camera and Microphone;
p4: Reload the page.
i1: If you do not see a Permissions section, then access to the camera and microphone is blocked at the Android operating system level. In Android Settings in the Applications section, make sure that Chrome is allowed to access the Camera and Microphone. After that, go back to Chrome and reload the page. Learn more on the
more: Android Support site
</i18n>

<i18n locale="ru" lang="yaml">
check: Не удалось получить доступ к камере и микрофону.
p1: Слева от адреса сайта нажмите на значок замка
p2: Нажмите на раздел Разрешения;
p3: Разрешите доступ к Камере и Микрофону;
p4: Перезагрузите страницу.
i1: Если вы не видите раздел Разрешения, значит доступ к камере и микрофону заблокирован на уровне операционной системы Android. В Настройках Android в разделе Приложения убедитесь, что для Chrome разрешён доступ к Камере и Микрофону. После этого вернитесь в Chrome и перезагрузите страницу. Подробнее на сайте
more: поддержки Android
</i18n>
